import React, { useState } from "react";
import { toast } from "sonner";
import { ShieldAlert, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

const cls = "w-full rounded-xl border border-gray-200 px-4 py-2.5 outline-none transition-colors focus:border-[#FF3B30] focus:ring-2 focus:ring-[#FF3B30]/20";

export default function Appeal() {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/appeals", { email, message }); setSent(true); toast.success(t("appeal_sent")); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-xl px-5 py-14 sm:px-8" data-testid="appeal-page">
      <div className="flex items-center gap-2 text-[#FF3B30]"><ShieldAlert size={22} /><span className="text-xs font-bold uppercase tracking-[0.2em]">{t("suspended_hint")}</span></div>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{t("appeal_title")}</h1>
      <p className="mt-3 text-gray-500">{t("appeal_sub")}</p>
      {sent ? (
        <div data-testid="appeal-success" className="mt-8 rounded-2xl bg-[#155724]/10 p-6 font-semibold text-[#155724]">{t("appeal_sent")}</div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="appeal-form">
          <input data-testid="appeal-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("appeal_email")} className={cls} />
          <textarea data-testid="appeal-message" required minLength={10} rows={6} value={message} onChange={(e) => setMessage(e.target.value)} placeholder={t("appeal_message")} className={cls} />
          <button data-testid="appeal-submit" disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[#FF3B30] px-6 py-3 text-sm font-bold text-white disabled:opacity-60">{busy && <Loader2 size={15} className="animate-spin" />} {t("appeal_send")}</button>
        </form>
      )}
    </div>
  );
}
